import { QueryState } from 'redux-query';
import { useSelector } from 'react-redux';
import { ForceRequestCallback, useRequest } from 'redux-query-react';
import { PhysicianInfo } from 'types';
import { getPracticeQuery } from 'modules/practice';
import { getBookablePhysicians } from './physicianSelectors';

export const usePhysicians = (
  practiceId: number,
): [PhysicianInfo[], QueryState, ForceRequestCallback] => {
  const [queryState, refresh] = useRequest(getPracticeQuery(practiceId));
  const physicians = useSelector(getBookablePhysicians);
  return [physicians, queryState, refresh];
};
